import Vue from 'vue';
import App from './App.vue';
import router from './router'; // Import the router
import AuthService from './auth/AuthService';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@fortawesome/fontawesome-free/css/all.css';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import axios from 'axios';

import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

const options = {
  transition: "Vue-Toastification__fade",
    // You can set your default options here
};

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.use(Toast, options);

Vue.prototype.$http = axios;

Vue.config.productionTip = false;

Vue.prototype.$auth = AuthService;

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'SpotJockeys Portal'; // Set page title
  next();
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Vue.prototype.$auth.isAuthenticated()) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

new Vue({router,
  render: (h) => h(App),
}).$mount('#app');
